import React, { useState, useRef } from "react";
import "./searchbar.css";
import { Drawer } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import useMediaQuery from "@material-ui/core/useMediaQuery";
const useStyles = makeStyles({});

const SearchBarContainer = (props) => {
  const [isSearching, setIsSearching] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  let textInput = useRef(null);
  const mdDown = useMediaQuery("(max-width: 1280px");

  return (
    <div
      className={classes.searchBarContainer}
      style={{
        width: mdDown ? "70%" : "50%",
        backgroundColor: "#f3f3f3",
        borderRadius: 24,
        height: 40,
        padding: "5px 15px 5px 25px",
      }}
    >
      <TextField
        id="input-with-icon-textfield"
        placeholder="Find your next adventure"
        autoFocus={false}
        onFocus={(e) => {
          props.openSearchDrawer();
        }}
        inputRef={textInput}
        onClick={() => {
          if (!isSearching) {
            setIsSearching(true);
          }
        }}
        onChange={(e) => {
          setIsSearching(true);
          props.handleSearchQuery(e.target.value);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {isSearching ? (
                <CloseIcon
                  style={{
                    background: theme.palette.primary.main,
                    borderRadius: 60,
                    padding: 3,
                    color: "white",
                  }}
                  onClick={() => {
                    props.hideSearchDrawer();
                    setIsSearching(false);
                  }}
                />
              ) : (
                <SearchIcon
                  style={{
                    background: theme.palette.primary.main,
                    borderRadius: 60,
                    padding: 3,
                    color: "white",
                  }}
                  onClick={() => {
                    props.openSearchDrawer();
                    setIsSearching(true);
                  }}
                />
              )}
            </InputAdornment>
          ),
          disableUnderline: true,
        }}
        style={{ width: "100%" }}
      />
    </div>
  );
};
export default SearchBarContainer;
